import { clock, urgency } from '@/features/live/live'
import { cn } from '@/lib/utils'

const BAR = { neutral: 'bg-ink/30', success: 'bg-success', warning: 'bg-warning', danger: 'bg-danger', info: 'bg-info', brand: 'bg-brand' } as const
const TEXT = { neutral: 'text-ink', success: 'text-success', warning: 'text-warning', danger: 'text-danger', info: 'text-info', brand: 'text-brand' } as const

/** Time left before the run gives up on this check, as a number that turns amber, then red. */
export function TimeLeft({ remaining, waited, className }: { remaining: number | null; waited: number; className?: string }) {
  if (remaining === null) {
    return (
      <span className={cn('num text-[13px] text-ink-muted', className)} title="Waiting so far">
        {clock(waited)}
      </span>
    )
  }
  const tone = urgency(remaining)
  return (
    <span className={cn('num text-[15px] font-semibold', TEXT[tone], remaining <= 30 && 'animate-pulse', className)} title="Time left before the run gives up">
      {clock(remaining)}
    </span>
  )
}

/** The same, as a bar that empties. */
export function TimeBar({ remaining, timeout, className }: { remaining: number | null; timeout: number | null; className?: string }) {
  if (remaining === null || !timeout) return null
  const tone = urgency(remaining)
  return (
    <div className={cn('h-1 w-full overflow-hidden rounded-pill bg-ink/[0.07]', className)} aria-hidden="true">
      <div className={cn('h-full rounded-pill transition-[width] duration-1000 ease-linear', BAR[tone])} style={{ width: `${Math.min(100, (remaining / timeout) * 100)}%` }} />
    </div>
  )
}
